import styled from 'styled-components';
import { Button, Label } from '../../../components/uielements';

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1.2fr 1fr;
  }

  /* Tablet and below: single column, form becomes a centered card
     floating on a soft background — matches the target mockup. */
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: center;
    background: ${({ theme }) => theme.palette.background[0]};
    /* padding: ${({ theme }) => theme.sizes.gap.big}; */
  }

  /* Mobile: drop the card, go back to edge-to-edge full screen. */
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    align-items: stretch;
    justify-items: stretch;
    padding: 0;
  }
`;

export const SectionLeft = styled.form`
  background-color: ${({ theme }) => theme.palette.background[2]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.gap.medium};
  padding: ${({ theme }) => theme.sizes.gap.big} 120px 0px 120px;
  box-sizing: border-box;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: ${({ theme }) => theme.sizes.gap.big} 64px 0px 64px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    justify-self: center;
    align-self: center;
    max-width: 560px;
    width: 100%;
    border-radius: ${({ theme }) => theme.sizes.borderRadius.tiny};
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    padding: ${({ theme }) => theme.sizes.gap.big} ${({ theme }) => theme.sizes.gap.medium};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    justify-self: stretch;
    align-self: stretch;
    max-width: 100%;
    border-radius: 0;
    box-shadow: none;
    padding: ${({ theme }) => theme.sizes.gap.normal} ${({ theme }) => theme.sizes.gap.normal} 0px;
    gap: ${({ theme }) => theme.sizes.gap.normal};
  }
`;

export const SectionLeftSignUp = styled.form`
  background-color: ${({ theme }) => theme.palette.background[2]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.gap.medium};
  padding: ${({ theme }) => theme.sizes.gap.big} 120px;
  box-sizing: border-box;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: ${({ theme }) => theme.sizes.gap.big} 64px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    justify-self: center;
    align-self: center;
    max-width: 560px;
    width: 100%;
    border-radius: ${({ theme }) => theme.sizes.borderRadius.tiny};
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    padding: ${({ theme }) => theme.sizes.gap.medium};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    justify-self: stretch;
    align-self: stretch;
    max-width: 100%;
    border-radius: 0;
    box-shadow: none;
    padding: ${({ theme }) => theme.sizes.gap.normal};
    gap: ${({ theme }) => theme.sizes.gap.normal};
  }
`;

export const SignInSectionRight = styled.section`
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const SignUpSectionRight = styled.section`
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
`;

export const ModalHeading = styled(Label).attrs({
  color: 'black',
  weight: 'bold',
})`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.sizes.font.medium};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.sizes.font.normal};
  }
`;

export const AltText = styled.p`
  font-family: 'Inter';
  font-size: ${({ theme }) => theme.sizes.font.medium};
  font-style: normal;
  font-weight: 400;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.sizes.font.normal};
  }
`;

export const LinkText = styled.span`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
    color: ${({ theme }) => theme.palette.color[0]};
  }
`;

export const ReestPasswordText = styled.span`
  font-size: ${({ theme }) => theme.sizes.font.normal};
  font-style: normal;
  cursor: pointer;
  width: fit-content;
  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  /* The acknowledgment paragraph has an inline style={{fontSize:'12px'}}
     in the JSX (not editable here) — !important is required to override
     an inline style from a stylesheet rule. */
  .acknowledgment-text {
    font-size: ${({ theme }) => theme.sizes.font.small} !important;
    line-height: 1.5 !important;
    color: #5a5e65;
  }
`;

export const InputLabel = styled.label`
  color: #73737e;
  font-family: 'Inter';
  font-size: ${({ theme }) => theme.sizes.font.small};
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.12px;
  margin-bottom: ${({ theme }) => theme.sizes.gap.tiny};
`;

export const HelperText = styled.div`
  color: red;
  font-size: ${({ theme }) => theme.sizes.font.small};
  margin-top: ${({ theme }) => theme.sizes.gap.tiny};
`;

export const Modal = styled.div`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  padding: ${({ theme }) => theme.sizes.gap.normal};
  box-sizing: border-box;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  background-color: #fff;
  padding: ${({ theme }) => theme.sizes.gap.big};
  border-radius: ${({ theme }) => theme.sizes.borderRadius.normal};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 450px;
  width: 100%;

  p {
    font-size: ${({ theme }) => theme.sizes.font.medium};
    margin-top: ${({ theme }) => theme.sizes.gap.small};
    color: #333;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.sizes.gap.medium};
  }
`;

export const StyledButton = styled(Button)`
  position: relative;
  width: 100%;
  /* Button's own stylesheet sets max-width: fit-content, which caps this
     back down to content size — same specificity as width:100% above, so
     it wins or loses depending on style injection order. !important
     removes that ambiguity and guarantees full width every time. */
  max-width: 100% !important;
  background-color: ${({ disabled, theme }) => (disabled ? '#ccc' : theme.palette.color[0])};
  color: ${({ disabled, theme }) => (disabled ? '#666' : theme.palette.text[0])};
  padding: ${({ theme }) => theme.sizes.gap.small} ${({ theme }) => theme.sizes.gap.normal};
  border: none;
  border-radius: ${({ theme }) => theme.sizes.borderRadius.small};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: ${({ theme }) => theme.sizes.font.medium};
  transition: background-color 0.3s ease;

  &:hover::after {
    content: ${({ disabled }) =>
      disabled ? '"Please acknowledge and check the box to proceed"' : '""'};
    position: absolute;
    bottom: -35px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: ${({ theme }) => theme.sizes.gap.tiny} ${({ theme }) => theme.sizes.gap.small};
    border-radius: ${({ theme }) => theme.sizes.borderRadius.tiny};
    font-size: ${({ theme }) => theme.sizes.font.small};
    white-space: nowrap;
    opacity: ${({ disabled }) => (disabled ? '1' : '0')};
    pointer-events: none;
    transition: opacity 0.3s ease;
  }
`;

export const IconButton = styled.button`
  position: absolute;
  right: 12px;
  top: 68%;
  transform: translateY(-50%);
  cursor: pointer;

  min-width: 44px;
  min-height: 44px;
  padding: ${({ theme }) => theme.sizes.gap.small};
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;

  &:focus-visible {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
    box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);
  }

  /* &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  } */

  &:active {
    background-color: rgba(0, 0, 0, 0.08);
  }

  @media (hover: none) {
    &:hover {
      background-color: transparent;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.sizes.gap.small};
  }
`;

export const PhoneInputContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: 100%;
  gap: ${({ theme }) => theme.sizes.gap.small};
  grid-template-columns: 1fr 4fr;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-auto-flow: row;
    grid-template-columns: 1fr;
  }
`;

export const CountryCodeSelect = styled.select`
  font-size: ${({ theme }) => theme.sizes.font.normal};
  padding: ${({ theme }) => theme.sizes.gap.small};
  border: 1px solid ${({ theme }) => theme.palette.border[0]};
  border-radius: ${({ theme }) => theme.sizes.borderRadius.tiny};
  background-color: #fff;
  color: #606266;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 110px;
  width: 100%;
  height: 100%;

  &:focus {
    border-color: ${({ theme }) => theme.palette.border[1]};
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 55%;
  right: 10px;
  transform: translateY(-55%);
  pointer-events: none;
`;
